import { createRoute } from '@tanstack/react-router'
import { mainLayoutRoute } from 'src/layouts/routes'
import { z } from 'zod'

import OrderList from '../pages/OrderList'

export const orderRoute = createRoute({
  getParentRoute: () => mainLayoutRoute,
  component: () => <OrderList />,
  path: '/order',
  validateSearch: (search) =>
    z
      .object({
        page: z.number().optional(),
        perPage: z.number().optional(),
        status: z.array(z.string()).optional(),
        paymentStatus: z.array(z.string()).optional(),
        departure: z.string().optional(),
        destination: z.string().optional(),
        departureDateFrom: z.string().optional(),
        departureDateTo: z.string().optional(),
        data: z.string().optional(),
        search: z.string().optional(),
        mode: z.enum(['filter', 'search']).optional()
      })
      .parse(search)
})
